module.exports = __webpack_public_path__ + "img/pizzas.88edf48.jpg";